module.exports = __webpack_public_path__ + "static/hometown-desktop.1cd7f9e0.webp";